import { userRoles } from '@/server/constants'

export default function ({ store, redirect }) {
  if (!store.state.user.user || !(store.state.user.actingAs & (userRoles.projectowner | userRoles.admin))) {
    return redirect('/')
  }
}
